import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout, message } from 'antd';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import { authService } from './services/authService';

const { Content } = Layout;

interface User {
  id: number;
  name: string;
  role: string;
}

const App: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const response = await authService.verifyToken();
        if (response.success) {
          setUser(response.user);
        } else {
          localStorage.removeItem('token');
        }
      }
    } catch (error) {
      console.error('验证令牌失败:', error);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (username: string, password: string) => {
    try {
      const response = await authService.login(username, password);
      if (response.success) {
        localStorage.setItem('token', response.token);
        setUser(response.user);
        message.success('登录成功！');
        return true;
      } else {
        message.error(response.error || '登录失败');
        return false;
      }
    } catch (error) {
      console.error('登录失败:', error);
      message.error('登录失败，请稍后重试');
      return false;
    }
  };

  const handleLogout = async () => {
    try {
      await authService.logout();
      localStorage.removeItem('token');
      setUser(null);
      message.success('登出成功！');
    } catch (error) {
      console.error('登出失败:', error);
      localStorage.removeItem('token');
      setUser(null);
    }
  };

  if (loading) {
    return (
      <Layout className="app-container">
        <Content className="loading-container">
          <div>正在加载...</div>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout className="app-container">
      <Routes>
        <Route
          path="/login"
          element={
            user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <LoginPage onLogin={handleLogin} />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            user ? (
              <Dashboard user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/"
          element={<Navigate to="/dashboard" replace />}
        />
      </Routes>
    </Layout>
  );
};

export default App;